import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IContentAppealFormProps } from "../../model/interface";
import { Input, Label } from "@fluentui/react-components";
import { EMAIL_MAX_LENGTH, NAME_MAX_LENGTH } from "../../constants/constants";
import Required from "../required/required";
import './ContentAppealForm.scss';
import { isEmailValid } from "../../utils/formValidator";

export default function ContentAppealForm(props: IContentAppealFormProps) {
    const [formName, setFormName] = useState<string>(props.appealerName !== "" ? props.appealerName : "");
    const [formEmail, setFormEmail] = useState<string>(props.contactEmail !== "" ? props.contactEmail : "");
    const [contactEmailError, setContactEmailError] = useState<string | null>(null);
    const { t } = useTranslation();

    const handleNameChange = (name: string) => {
        const newName = name;
        setFormName(newName);
        props.nameChange(newName);
    }

    const handleEmailChange = (email: string) => {
        const newEmail = email;
        setFormEmail(newEmail);
        props.emailChange(newEmail);
    }

    const validateEmail = (email: string) => {
        if (!email) {
            setContactEmailError(null);
            return;
        }
        if (!isEmailValid(email)) {
            setContactEmailError(t("Appeal.Common.email-invalid"));
        } else {
            setContactEmailError(null);
        }
    };

    return (
        <div>
            <div className="form-overview">
                <h1 className="form-overview__header"> {t('Appeal.Common.submit-an-appeal')}</h1>
                <p className="form-overview__paragraph">{t('Appeal.Common.appeal-overview')}</p>
            </div>
            <div className="form-fields">
                <div className="policy-violated">
                    <Label id="policyViolatedLabel">{t('Appeal.Common.policy-violated')}</Label>
                    <Input
                        id="policyViolated"
                        aria-labelledby="policyViolatedLabel"
                        type="text"
                        value={props.policyViolation ? props.policyViolation : ""}
                        disabled
                    />
                </div>
                <div className="name">
                    <Label id="nameLabel">
                        {t('Appeal.Common.name')}
                        <span><Required /></span>
                    </Label>
                    <Input
                        id="appealerName"
                        aria-labelledby="nameLabel"
                        data-testid="appealerName"
                        type="text"
                        value={formName !== "" ? formName : props.currentFormInfo.appealerName}
                        onChange={(e: any, data: { value: string; }) => handleNameChange(data.value)}
                        maxLength={NAME_MAX_LENGTH}
                        autoFocus
                    />
                </div>
                <div className="email">
                    <Label id="contactEmailLabel">
                        {t('Appeal.Common.contact-email')}
                        <span><Required /></span>
                    </Label>
                    <Input
                        id="contactEmail"
                        aria-labelledby="contactEmailLabel"
                        data-testid="contactEmail"
                        type="email"
                        required
                        value={formEmail !== "" ? formEmail : props.currentFormInfo.contactEmail}
                        onChange={(e: any, data: { value: string; }) => handleEmailChange(data.value)}
                        onBlur={() => validateEmail(props.contactEmail !== "" ? props.contactEmail : props.currentFormInfo.contactEmail)}
                        maxLength={EMAIL_MAX_LENGTH}
                    />
                    {contactEmailError && (
                        <span className="error-message" role="alert">{contactEmailError}</span>
                    )}
                </div>
                <div className="product">
                    <Label id="productLabel">{t('Appeal.Common.service-or-product')}</Label>
                    <Input
                        id="product"
                        aria-labelledby="productLabel"
                        type="text"
                        disabled
                        value={props.product ? props.product : ""}
                    />
                    <span className="subtext"> {t('Appeal.Common.service-or-product-subtext')}</span>
                </div>
            </div>
        </div>
    );
};